import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_DATA = createAsyncTypes(
  'FETCH_DATA_REQUEST',
  'IronScales/Dashboard/Home/MailboxesStatus'
)

export const SUBMIT_MAILBOX_UPDATE = createAsyncTypes(
  'SUBMIT_MAILBOX_UPDATE_REQUEST',
  'IronScales/Dashboard/Home/MailboxesStatus'
)

export const MAILBOXES_TO_ADD_COUNTER_CHANGE =
  'IronScales/Dashboard/Home/MailboxesStatus/MAILBOXES_TO_ADD_COUNTER_CHANGE'

export const ERROR_MESSAGE = 'The requested data cannot be displayed. Please try again later.'

export const DEFAULT_MAILBOXES_TO_ADD = 0

export const mapIntegrationByType = {
  '0365': 'office365',
  gmail: 'google-workspace',
}
